<script>
    import{user_data} from './stores.js';
    import { onMount } from "svelte";
    import Iqtemplate from "./components/iqtemplate.svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";
    import Chipscompnent from './components/chipscompnent.svelte';

    export let chipsdata = [
        {s: true, t: "Single Family", i:"/img/House.svg", cbf:()=>{$user_data.propertytype = "Single Family"}},
        {s: false, t: "Condo", i:"/img/Condo.svg", cbf:()=>{$user_data.propertytype = "Condo"}},
        {s: false, t: "Multi-unit", i:"/img/Multi-Unit.svg", cbf:()=>{$user_data.propertytype = "Multi-unit"}},
    ];

    console.log("chipsdata: ", chipsdata);

    // onMount(async() => {

    // });

</script>

<Iqtemplate
progress_mobile_version={true}
>
    <Progresscomponent 
    title="What property type would this be?"
    show_next_button={false}
    >
    <Chipscompnent
        bind:chipsdata={chipsdata}
    />
    </Progresscomponent>
</Iqtemplate>

<style>

</style>